/**
 * Directive: loader
 */
angular.module('acme.common.directive.loader', [])
.directive('loader', [function() {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/loader/loader.tpl.html',
      scope: {
        loaderId: '@',
        hidden: '@'
      },
      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', function($scope) {

        $scope.loader = {

          hidden: false,

          init: function() {

            this.hidden = ($scope.hidden);

            $scope.$on('loader['+$scope.loaderId+']::show', this.onShow);
            $scope.$on('loader['+$scope.loaderId+']::hide', this.onHide);

          },

          onShow: function(e, data) {
            console.log('loader['+$scope.loaderId+']::onShow');
            $scope.loader.hidden = false;
          },

          onHide: function(e, data) {
            console.log('loader['+$scope.loaderId+']::onHide');
            $scope.loader.hidden = true;
          }

        };

        $scope.loader.init();

      }]

    };

}]);